import React, { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import AppLoading from '../components/UI/atoms/AppLoading';
import { withTranslation } from 'next-i18next';
import { useAuth, hasRole } from '@lb-classroom/feature-auth';
import { serverSideTranslations } from '@lib/i18n';

const Home = ({ i18n }) => {
  const { currentUser, loading } = useAuth();
  const router = useRouter();
  const hasRedirected = useRef(false);

  useEffect(() => {
    if (hasRedirected.current) return;
    if (loading) return;

    hasRedirected.current = true;

    if (currentUser) {
      const isTutor = hasRole(currentUser.profile_type, 'Tutor');
      const isStudent = hasRole(currentUser.profile_type, 'Student');

      // Tutors (including admins with both roles) go to tutor dashboard
      if (isTutor) {
        router.push('/t/dashboard');
      } else if (isStudent) {
        // Students go to onboarding path when incomplete, otherwise dashboard.
        const nextPath = currentUser.onboarding_next_path || '/s/dashboard';
        const userLocale = currentUser.locale?.i18n_form;
        if (userLocale) {
          i18n.changeLanguage(userLocale);
          router.push(nextPath, nextPath, {
            locale: userLocale,
          });
        } else {
          router.push(nextPath);
        }
      } else {
        // Unknown role, redirect to login
        router.push('/login');
      }
    } else {
      router.push('/login');
    }
  }, [router, loading, currentUser, i18n]);

  return <AppLoading />;
};

export async function getServerSideProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
      // Will be passed to the page component as props
    },
  };
}

const wrapped = withTranslation('common')(Home);
export default wrapped;
